module.exports = __webpack_public_path__ + "img/gywm.6a3e7ffa.png";